// useImportedFiles.ts
import { useState } from "react";

export const useImportedFiles = () => {
  const [files, setFiles] = useState<File[]>([]);

  const addFiles = (incoming: FileList | File[]) => {
    const array = Array.from(incoming);
    setFiles((prev) => [...prev, ...array]);
  };

  const clearFiles = () => {
    setFiles([]);
  };

  const removeFile = (index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };

  return {
    files,
    addFiles,
    clearFiles,
    removeFile,
  };
};
